import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function BigIconFieldReadOnly(props) {
  const { classes, icon, label, value, empty, action, valueSize } = props;

  const Icon = icon;

  return (
    <div
      className={
        action ? `${classes.containerWithAction} ${classes.root}` : classes.root
      }
    >
      <Icon className={`${classes.icon} ItemIcon`} />
      <div>
        <Typography className={classes.label}>{label}</Typography>
        <Typography
          className={
            valueSize == 'sm'
              ? classes.smValue
              : valueSize == 'xs'
              ? classes.xsValue
              : classes.value
          }
        >
          {value}
        </Typography>
        {action ? <div className={classes.action}>{action}</div> : null}
      </div>
    </div>
  );
}

BigIconFieldReadOnly.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
  isDefault: PropTypes.bool,
  action: PropTypes.object,
  valueSize: PropTypes.string,
};

BigIconFieldReadOnly.defaultProps = {
  value: '',
  empty: false,
  action: null,
  valueSize: 'default',
};

export default withStyles(styles)(BigIconFieldReadOnly);
